import { useEffect, useState } from "react"

import { Link } from "@/components/marketing/elements/link"
import {
  dismissAnalyticsNotice,
  getUmamiConfig,
  isAnalyticsNoticeDismissed,
  isAnalyticsOptedOut,
  setAnalyticsOptOut,
  shouldLoadUmami,
} from "@/lib/umami"

export function AnalyticsNotice() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (!getUmamiConfig()) return
    if (isAnalyticsOptedOut() || isAnalyticsNoticeDismissed()) return
    setVisible(true)
  }, [])

  if (!visible) return null

  function handleDismiss() {
    dismissAnalyticsNotice()
    setVisible(false)
  }

  function handleOptOut() {
    setAnalyticsOptOut(true)
    dismissAnalyticsNotice()
    setVisible(false)
  }

  const analyticsActive = shouldLoadUmami()

  return (
    <div
      role="region"
      aria-label="Analytics notice"
      className="fixed inset-x-0 bottom-0 z-50 border-t border-mauve-950/10 bg-mauve-50/95 p-4 shadow-lg backdrop-blur-sm dark:border-white/10 dark:bg-mauve-950/95"
    >
      <div className="mx-auto flex max-w-4xl flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm/6 text-mauve-800 dark:text-mauve-300">
          {analyticsActive ? (
            <>
              We use{" "}
              <a
                href="https://umami.is"
                className="underline decoration-mauve-950/30 underline-offset-2 hover:decoration-mauve-950 dark:decoration-white/30 dark:hover:decoration-white"
                rel="noopener noreferrer"
                target="_blank"
              >
                Umami
              </a>{" "}
              on this site — privacy-friendly analytics with no cookies and no ad tracking. We see aggregate page views
              only. Details in our{" "}
              <Link href="/legal/privacy#analytics" className="underline underline-offset-2">
                privacy policy
              </Link>
              .
            </>
          ) : (
            <>
              Analytics are off because you opted out or enabled Do Not Track. See our{" "}
              <Link href="/legal/privacy#analytics" className="underline underline-offset-2">
                privacy policy
              </Link>
              .
            </>
          )}
        </p>
        <div className="flex shrink-0 flex-wrap gap-2">
          {analyticsActive ? (
            <button
              type="button"
              onClick={handleOptOut}
              className="rounded-md px-3 py-1.5 text-sm text-mauve-700 hover:bg-mauve-950/5 dark:text-mauve-300 dark:hover:bg-white/10"
            >
              Opt out
            </button>
          ) : null}
          <button
            type="button"
            onClick={handleDismiss}
            className="rounded-md bg-mauve-950 px-3 py-1.5 text-sm font-medium text-white hover:bg-mauve-800 dark:bg-white dark:text-mauve-950 dark:hover:bg-mauve-100"
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  )
}
